import React, { memo } from 'react'
import styles from './CommonSideDialog.module.scss'

type Props = {
    children: React.ReactNode
    onCloseDialog: () => void
}

const CommonSideDialog: React.FC<Props> = memo((props: Props) => {

    function handleChildClick(event : React.MouseEvent<HTMLDivElement>) {
        event.stopPropagation();
    }

    return (
        <div className={styles.container} onClick={props.onCloseDialog}>
            <div className={styles.dialogContainer} onClick={handleChildClick}>
                {props.children}
            </div>
        </div>
    )
})

export default CommonSideDialog